import script from "./CalculatorsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalculatorsPage.vue?vue&type=script&setup=true&lang=ts"

import "./CalculatorsPage.vue?vue&type=style&index=0&id=cdf64eda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdf64eda"]])

export default __exports__